import { RootState } from '@checkout/state';
import * as React from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { Persistor } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import { Receipt } from './../components/container';
import { contextCheckoutConfig } from './../config/contextCheckoutConfig';
import { ICheckoutContextConfig } from './../config/contextCheckoutConfig.d';
import { getConfigContextValue } from './../utils/utils';
import ConnectedIntlProvider from './../wrappers/ConnectedIntlProvider';
import ErrorBoundary from './../wrappers/ErrorBoundary';
import { CheckoutContextConfig } from './CheckoutApp';

interface IOwnProps {
  store: Store<RootState>;
  persistor: Persistor;
  checkoutConfig?: Partial<ICheckoutContextConfig>;
  intlData?: IntlProvider.Props;
}

const ReceiptApp: React.SFC<IOwnProps> = ({ store, persistor, checkoutConfig, intlData }) => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ConnectedIntlProvider {...intlData} >
        <ErrorBoundary>
          <CheckoutContextConfig.Provider value={getConfigContextValue<ICheckoutContextConfig>(contextCheckoutConfig, checkoutConfig)}>
            <Receipt />
          </CheckoutContextConfig.Provider>
        </ErrorBoundary>
      </ConnectedIntlProvider>
    </PersistGate>
  </Provider>
);

export default ReceiptApp;
